// Column definitions for the Users list in settings
const defaultSort = {
	defaultSortField: 'templateName',
	defaultSortOrder: 'asc',
}

export default {
	'prodTemplates': {
		...defaultSort,
		gutterOpts: {
			buttons: [
				// {
				//   event: 'columnChooser',
				//   icon: 'icon-tablecolumns',
				//   tooltip: 'Customize Columns',
				//   isLine: true,
				// }
			],
		},
		toolBar: {
			buttons: [
				{
					event: 'openActivity',
					icon: 'icon-activityhistory',
					tooltip: 'Activity History',
					isLine: true,
				},
				{
					event: 'addNew',
					icon: 'icon-addnew',
					isLine: true,
					tooltip: 'Create New Template',
					permissionModule: 'app&projects',
					alterDataKey: 'company_templates',
				},
			],
			bulkActions: () => { },
		},
		fields: [
			{
				title: 'Template Name',
				name: 'templateName',
				width: '256px',
				id: 'templateName',
				sortField: 'templateName',
				prop: 'templateName',
				defaultVisible: true,
				openCard: true
			},
			{
				title: 'Template Id',
				name: 'templateId',
				width: '152px',
				id: 'templateId',
				sortField: 'templateId',
				prop: 'templateId',
				defaultVisible: true,
			},
			{
				title: 'Type',
				name: 'type',
				width: '96px',
				id: 'type',
				prop: 'type',
				defaultVisible: true,
			},
			{
				title: 'Order Name',
				name: 'name',
				width: '256px',
				id: 'name',
				sortField: 'name',
				prop: 'name',
				defaultVisible: true,
				sortField: 'name',
			}, {
				title: 'Default',
				name: 'isDefault',
				width: '96px',
				id: 'isDefault',
				prop: 'isDefault',
				defaultVisible: true,
			}, {
				title: 'Stage Used',
				name: 'stageUsed',
				width: '120px',
				id: 'stageUsed',
				prop: 'stageUsed',
				defaultVisible: true,
			}, {
				title: 'Actions',
				id: 'action',
				hideFromChooser: true,
				alwaysVisible: true,
				sticky: true,
				width: '112px',
				thAttrs: () => ({ class: 'action-sticky' }),
				tdClass: 'action-sticky',
				inputProps: {
					showEdit: false,
					options: () => {
						return [
							{
								icon: 'icon-clone',
								label: 'Clone',
								event: 'cloneTemplate',
								tooltip: 'Clone Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
							{
								icon: 'icon-bin',
								event: 'removeTemplate',
								tooltip: 'Delete Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
						]
					},
					groupButtons(rowData) {
						return [
							{
								icon: 'icon-edit',
								event: 'editTemplate',
								tooltip: 'Edit Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
						];
					},
				},
			},
			// Add more columns as needed
		]
	},
	'matTemplates': {
		...defaultSort,
		gutterOpts: {
			buttons: [],
		},
		toolBar: {
			buttons: [
				{
					event: 'openActivity',
					icon: 'icon-activityhistory',
					tooltip: 'Activity History',
					isLine: true,
				},
				{
					event: 'addNew',
					icon: 'icon-addnew',
					isLine: true,
					tooltip: 'Create New Template',
					permissionModule: 'app&projects',
					alterDataKey: 'company_templates',
				},
			],
			bulkActions: () => { },
		},
		fields: [
			{
				title: 'Template Name',
				name: 'templateName',
				width: '256px',
				id: 'templateName',
				sortField: 'templateName',
				prop: 'templateName',
				defaultVisible: true,
				openCard: true
			},
			{
				title: 'Template Id',
				name: 'templateId',
				width: '152px',
				id: 'templateId',
				sortField: 'templateId',
				prop: 'templateId',
				defaultVisible: true,
			},
			{
				title: 'Type',
				name: 'type',
				width: '96px',
				id: 'type ',
				prop: 'type',
				defaultVisible: true,
			},
			{
				title: 'Order Name',
				name: 'name',
				width: '120px',
				id: 'name',
				prop: 'name',
				defaultVisible: true,
				sortField: 'name',
			}, {
				title: 'Default',
				name: 'isDefault',
				width: '96px',
				id: 'isDefault',
				prop: 'isDefault',
				defaultVisible: true,
			}, {
				title: 'Stage Used',
				name: 'stageUsed',
				width: '120px',
				id: 'stageUsed',
				prop: 'stageUsed',
				defaultVisible: true,
			}, {
				title: 'Actions',
				id: 'action',
				hideFromChooser: true,
				alwaysVisible: true,
				sticky: true,
				width: '112px',
				thAttrs: () => ({ class: 'action-sticky' }),
				tdClass: 'action-sticky',
				inputProps: {
					showEdit: false,
					options: () => {
						return [
							{
								icon: 'icon-clone',
								label: 'Clone',
								event: 'cloneTemplate',
								tooltip: 'Clone Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
							{
								icon: 'icon-bin',
								event: 'removeTemplate',
								tooltip: 'Delete Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
						]
					},
					groupButtons(rowData) {
						return [
							{
								icon: 'icon-edit',
								event: 'editTemplate',
								tooltip: 'Edit Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
						];
					},
				},
			},
			// Add more columns as needed
		]
	},
	'formTemplates': {
		gutterOpts: {
			buttons: [],
		},
		toolBar: {
			buttons: [
					{
					event: 'openActivity',
					icon: 'icon-activityhistory',
					tooltip: 'Activity History',
					isLine: true,
				},
				{
					event: 'addFormTemplate',
					icon: 'icon-addnew',
					isLine: true,
					tooltip: 'Create New Template',
					permissionModule: 'app&projects',
					alterDataKey: 'company_templates',
				},
			],
			bulkActions: () => { },
		},
		fields: [
			{
				title: 'Template Name',
				name: 'templateName',
				width: '400px',
				id: 'templateName',
				sortField: 'templateName',
				prop: 'templateName',
				defaultVisible: true,
				isForms: true,
                openCard: true
			}, {
				title: 'Template Id',
				name: 'templateId',
				width: '196px',
				id: 'templateId',
				sortField: 'templateId',
				prop: 'templateId',
				defaultVisible: true,
			},
			{
				title: 'Use in Shipping Orders',
				name: '',
				width: '128px',
				id: 'useInShipping',
				prop: 'useInShipping',
				defaultVisible: true,
			}, {
				title: 'Actions',
				id: 'action',
				hideFromChooser: true,
				alwaysVisible: true,
				sticky: true,
				width: '112px',
				thAttrs: () => ({ class: 'action-sticky' }),
				tdClass: 'action-sticky',
				inputProps: {
					showEdit: false,
					options: () => {
						return [
							
							{
								icon: 'icon-clone',
								label: 'Clone',
								event: 'cloneTemplate',
								tooltip: 'Clone Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
							{
								icon: 'icon-bin',
								label: 'Remove',
								event: 'removeTemplate',
								tooltip: 'Delete Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
						]
					},
					groupButtons(rowData) {
						return [
							{
								icon: 'icon-edit',
								event: 'editTemplate',
								tooltip: 'Edit Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
						];
					},
				},
			},
			// Add more columns as needed
		]
	},
	'qcFormTemplates': {
		gutterOpts: {
			buttons: [],
		},
		toolBar: {
			buttons: [
				{
					event: 'openActivity',
					icon: 'icon-activityhistory',
					tooltip: 'Activity History',
					isLine: true,
				},
				{
					event: 'addQcFormTemplate',
					icon: 'icon-addnew',
					isLine: true,
					tooltip: 'Create New Template',
					permissionModule: 'app&projects',
					alterDataKey: 'company_templates',
				},
				
			],
			bulkActions: () => { },
		},
		fields: [
			{
				title: 'Form Name',
				name: 'formName',
				width: '400px',
				id: 'formName',
				prop: 'name',
				defaultVisible: true,
				openCard: true
			}, {
				title: 'Form Id',
				name: 'formId',
				width: '152px',
				id: 'formId',
				prop: 'formId',
				defaultVisible: true,
			},
			{
				title: 'Actions',
				id: 'action',
				hideFromChooser: true,
				alwaysVisible: true,
				sticky: true,
				width: '112px',
				thAttrs: () => ({ class: 'action-sticky' }),
				tdClass: 'action-sticky',
				inputProps: {
					showEdit: false,
					options: () => {
						return [
							{
								icon: 'icon-clone',
								label: 'Clone',
								event: 'cloneTemplate',
								tooltip: 'Clone Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
							{
								label: 'Remove',
								icon: 'icon-bin',
								event: 'removeTemplate',
								isDisabled: (rowData) => rowData?.isUsed,
								tooltip: 'Delete Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
						]
					},
					groupButtons(rowData) {
						return [
							{
								icon: 'icon-edit',
								event: 'editTemplate',
								tooltip: 'Edit Template',
								permissionModule: 'app&projects',
								alterDataKey: 'company_templates',
							},
						];
					},
				},
			},
			// Add more columns as needed
		]
	},

}